import React, { useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";

function Help() {
    const scriptURL = "https://script.google.com/macros/s/AKfycbzoRreRrLMOur3fdlhX-sFfoT_VRkhL9_gQS1ZWxI_QWS1SrAJQ9hHx_ikATLcKo3E/exec";

    const [Email, setEmail] = useState("");
    const [Message, setMessage] = useState("");

    const [SubmitButton, setSubmitButton] = useState(false);
    const [LoadingButton, setLoadingButton] = useState(true);
    const [AlertButton, setAlertButton] = useState(true);

    const Opposite = () => {
        setSubmitButton(!SubmitButton);
        setLoadingButton(!LoadingButton);
        setAlertButton(!AlertButton);
    };

    const Reset = () => {
        setEmail("");
        setMessage("");
    };

    const form = document.getElementById("helpForm");
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitButton(!SubmitButton);
        setLoadingButton(!LoadingButton);
        fetch(scriptURL, { method: "POST", body: new FormData(form) })
            .then((response) => {
                Opposite();
                Reset();
                console.log("Success!", response);
            })
            .catch((error) => {
                alert("Whoa! Seem's like there's an error, please try again or refresh the page.");
                console.error("Error!", error.message);
            });
    };

    return (
        <React.Fragment>
            <div className="container w-full mx-auto font-poppins">
                <header className="mx-auto pt-32">
                    <h1 className="text-center text-3xl font-bold text-sky-400">Sending Feedback / Report</h1>
                </header>
                <form
                    onSubmit={handleSubmit}
                    name="helpForm"
                    id="helpForm"
                    className="lg:w-6/12 w-11/12 my-10  flex flex-col lg:p-10 px-8 py-4 justify-center items-center mx-auto bg-slate-800 bg-opacity-50 border-4 border-slate-800 rounded-xl h-max"
                >
                    <label className="mb-4 block w-full">
                        <span className="text-slate-200">Email</span>
                        <input
                            type="email"
                            maxLength={50}
                            name="Email"
                            value={Email}
                            onChange={(e) => setEmail(e.target.value)}
                            className=" bg-slate-900 text-white border-slate-700  mt-1 block rounded-lg w-full"
                            required
                            placeholder="John@gmail.com"
                        />
                    </label>
                    <div className="mb-4 block w-full">
                        <span className="text-slate-200">Help Type</span>
                        <div className="mt-2">
                            <label className="inline-flex items-center">
                                <input type="radio" className="form-radio" name="Help Type" value="Feedback" required />
                                <span className="text-white ml-2">Feedback</span>
                            </label>
                            <label className="inline-flex items-center ml-3 sm:ml-6">
                                <input type="radio" className="form-radioname=" name="Help Type" value="Report a Problem" />
                                <span className="text-white ml-2">Report a Problem</span>
                            </label>
                        </div>
                    </div>
                    <label className="block mb-4 w-full">
                        <span className="text-slate-200">Message</span>
                        <textarea
                            required
                            name="Message"
                            value={Message}
                            onChange={(e) => setMessage(e.target.value)}
                            className="form-textarea bg-slate-900 text-white border-slate-700  mt-1 block rounded-lg w-full"
                            rows="3"
                            placeholder="Write something..."
                        ></textarea>
                    </label>
                    <div className={AlertButton ? "hidden" : "mb-5 flex lg:p-3 px-4 py-2 text-slate-300 gap-4 justify-center items-center mx-auto bg-slate-800 border-4 border-slate-800 rounded-xl h-max"} role="alert">
                        Big thanks! Your message has been recieved. We appreciate your help.
                        <button
                            type="button"
                            onClick={() => {
                                setAlertButton(!AlertButton);
                                setSubmitButton(!SubmitButton);
                                setLoadingButton(!LoadingButton);
                            }}
                            className="btn-close"
                            data-bs-dismiss="alert"
                            aria-label="Close"
                        >
                            <AiFillCloseCircle size={"20px"} />
                        </button>
                    </div>
                    <button
                        type="submit"
                        className={
                            SubmitButton
                                ? "hidden"
                                : " z-10 mb-4 focus:outline-none focus:ring-2 text-white font-semibold h-10 px-4 lg:px-6 rounded-lg flex items-center justify-center mx-auto w-full text-center bg-green-600 hover:bg-green-700"
                        }
                    >
                        Submit
                    </button>
                    <button
                        className={
                            LoadingButton
                                ? "hidden"
                                : "opacity-80 z-10 mb-4 focus:outline-none focus:ring-2 text-white font-semibold h-10 px-4 lg:px-6 rounded-lg flex items-center justify-center mx-auto w-full text-center bg-green-800 hover:bg-green-900"
                        }
                        type="button"
                        disabled
                    >
                        <span className="spinner-border mr-2 spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...
                    </button>
                </form>
            </div>
        </React.Fragment>
    );
}
export default Help;
